import { FC, memo } from 'react'

import { ContentUnavailableElem } from './styles'

export type ContentUnavailableProps = {
  children: React.ReactNode
}

const ContentUnavailableRaw: FC<ContentUnavailableProps> = ({ children }) => {
  return <ContentUnavailableElem>{children}</ContentUnavailableElem>
}

export const ContentUnavailable = memo(ContentUnavailableRaw)
